export const FeedBack = {
  EMAILNULL: "メールアドレスをご入力ください。",
  PASSWORDNULL: "パスワードをご入力ください。",
  PASSWORDINCORRECT: "パスワードが一致しませんでした。",
  FIRSTNAMENULL: "「名」をご入力ください。",
  LASTNAMENULL: "「姓」をご入力ください。",
  STORENAMENULL: "お店の名前をご入力ください。",
  EMAIL_INVALID: "メールアドレスの形式が無効でございます",
  DELETE_SUCCESS: "削除しました。",
  INVALID: "無効",
  REQUIRED: "必須",
  UPDATE_SUCCESS: "更新しました。",
  CREATE_SUCCESS: "作成しました。",
  MAX_LENGTH_255: "全半角255文字以内でご入力をお願いします。",
  DATA_EMPTY: "データがございませんでした。",
  SLAG_NAME_NULL: "スラグ名をご入力ください。",
  SLAG_NAME_EN_NULL: "スラグ名（英字）をご入力ください。",
  REGISTER_URL_NULL: "スラグ付与用会員登録URLをご入力ください。",
  LOGIN_URL_NULL: "スラグ付与用ログインURLをご入力ください。",
  REDIRECT_URL_NULL: "スラグ付与後リダイレクトURLをご入力ください。",
  URL_NOT_REGEX: "URLの形式が無効でございます。",
  PASSWORD_NULL: "パスワードをご入力ください。",
  PASSWORD_8_CHARACTER: "パスワードは8文字以上のご入力をお願いします。",
  ALPHANUMERIC_PASSWORD: "パスワードは8桁以上の英数字でご入力をお願いします。",
  PROVINCE_NULL: "都道府県のご入力をお願いします。",
  POSTALCODE_NULL: "郵便番号のご入力をお願いします。",
  ADDRESS_NULL: "市区町村番地のご入力をお願いします。",
};
